module.exports = __webpack_public_path__ + "static/img/33-2.9d580fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/33-2.jpg
// module id = +EFc
// module chunks = 0